import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Eye, EyeOff, Lock, User } from 'lucide-react';
import AuthInput from './AuthInput';
import AuthButton from './AuthButton';
import { validatePassword } from './useAuthActions';

export default function LoginForm({ onSubmit, loading, initialUsername = '' }) {
  const [showPassword, setShowPassword] = useState(false);
  const [formData, setFormData] = useState({
    username: initialUsername,
    password: '',
  });
  const [touched, setTouched] = useState({});

  const getFieldError = (field) => {
    if (!touched[field]) return null;
    if (field === 'username' && formData.username.length > 0 && formData.username.length < 3) {
      return 'Username must be at least 3 characters';
    }
    if (field === 'password' && formData.password && !validatePassword(formData.password)) {
      return 'Password must be at least 6 characters';
    }
    return null;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleBlur = (field) => {
    setTouched((prev) => ({ ...prev, [field]: true }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setTouched({ username: true, password: true });
    onSubmit(formData);
  };

  return (
    <form onSubmit={handleSubmit} className="flex flex-col gap-5">
      <AuthInput
        label="Username"
        name="username"
        value={formData.username}
        onChange={handleChange}
        onBlur={() => handleBlur('username')}
        placeholder="Enter your username"
        required
        autoComplete="username"
        icon={User}
        error={getFieldError('username')}
      />

      <AuthInput
        label="Password"
        name="password"
        type={showPassword ? 'text' : 'password'}
        value={formData.password}
        onChange={handleChange}
        onBlur={() => handleBlur('password')}
        placeholder="Enter your password"
        required
        autoComplete="current-password"
        icon={Lock}
        error={getFieldError('password')}
        trailing={
          <button
            type="button"
            onClick={() => setShowPassword((v) => !v)}
            className="text-gray-400 transition-colors hover:text-teal-600"
            aria-label={showPassword ? 'Hide password' : 'Show password'}
          >
            {showPassword ? <EyeOff className="h-5 w-5" /> : <Eye className="h-5 w-5" />}
          </button>
        }
      />

      <div className="-mt-2 text-right">
        <Link
          to="/forgot-password"
          className="text-sm font-semibold text-teal-700 hover:text-teal-800 hover:underline"
        >
          Forgot password?
        </Link>
      </div>

      <AuthButton type="submit" loading={loading}>
        Sign in
      </AuthButton>
    </form>
  );
}
